import { addEventListener, removeEventListener } from 'dom-helpers';
import React, { Component, createRef, RefObject } from 'react';
import { Swiper } from 'swiper';

interface SliderProps {
  slides: Array<any>;
  position?: number;
  onPosition?: { (position: number): void };
  onSetSlider?: (swiper: Swiper) => void;
}

export class ImageSlider extends Component<SliderProps> {
  private ref: RefObject<HTMLDivElement> = createRef();
  private createSlider: any;
  private slider: Swiper | null = null;

  componentDidMount() {
    this.setupSlider();

    addEventListener(document.body, 'keydown', this.onKeyPress);
  }

  componentWillUnmount() {
    removeEventListener(document.body, 'keydown', this.onKeyPress);
    if (this.slider) {
      this.slider.destroy();
    }
  }

  onKeyPress = (e: KeyboardEvent) => {
    if (!this.slider) {
      return;
    }

    if (e.key === 'ArrowRight') {
      this.slider.slideNext();
    }

    if (e.key === 'ArrowLeft') {
      this.slider.slidePrev();
    }
  };

  setupSlider = async () => {
    if (!this.ref || !this.ref.current) {
      return;
    }

    if (!this.createSlider) {
      try {
        this.createSlider = (await import('utils/createSlider')).default;
      } catch (_) {}
    }

    if (this.createSlider) {
      const [swiper] = this.createSlider(this.ref.current, {
        autoplay: false,
        zoom: true,
      });

      if (this.slider) {
        this.slider.destroy(false);
      }
      this.slider = swiper;

      if (swiper && this.props.onSetSlider) {
        this.props.onSetSlider(swiper);
      }
    }
  };

  render() {
    const {
      props: { slides },
    } = this;
    return (
      <div ref={this.ref} className="ebslider">
        <div className="swiper-container">
          <div className="ebslider__items swiper-wrapper">
            {slides.map((slide, arrIndex) => (
              <div key={arrIndex} className="swiper-slide">
                {slide}
              </div>
            ))}
          </div>
        </div>
        <div className="img-slider__nav ebslider__prev is-left">
          <div className="button is-circle has-icon">
            <span className="eb eb-rr" />
          </div>
        </div>

        <div className="img-slider__nav ebslider__next is-right">
          <div className="button is-circle has-icon">
            <span className="eb eb-rl" />
          </div>
        </div>
      </div>
    );
  }
}

// interface SliderState {
//   position: number
//   destination: number
//   dragStart: number
//   dragStartTime?: Date
//   dragVelocity: number
// }

// import React, {
//   Component,
//   createRef,
//   CSSProperties,
//   RefObject,
//   TouchEvent,
// } from 'react'
//
// const PRELOAD_BACK = 1
// const PRELOAD_FORWARD = 2
// const VELOCITY_TRACKING = 0.5
//
// const style: Record<string, CSSProperties> = {
//   slider: {
//     overflow: 'hidden',
//     display: 'flex',
//     flexDirection: 'column',
//   },
//
//   slider__inner: {
//     height: '100%',
//   },
//
//   slider__slides: {
//     height: '100%',
//     display: 'flex',
//   },
//
//   slider__slide: {
//     flexBasis: 0,
//     flexGrow: 1,
//   },
// }
//
// const toRange = (value: number, range: number) =>
//   ((value % range) + range) % range
//
// const getTouchX = (event: TouchEvent) => event.touches[0].pageX
//
//
// export class ImageSlider extends Component<SliderProps, SliderState> {
//   private ref: RefObject<HTMLDivElement> = createRef()
//
//   constructor(props) {
//     super(props)
//
//     this.state = {
//       position: props.position || 0,
//       destination: 0,
//       dragStart: 0,
//       dragVelocity: 0,
//     }
//
//     this.index = -1
//   }
//
//   private scheduled: any
//
//   private index: number
//
//   private animate = () => {
//     if (this.scheduled) {
//       return
//     }
//
//     this.scheduled = requestAnimationFrame(() => {
//       this.scheduled = false
//
//       const distance = this.state.destination - this.state.position
//
//       if (Math.abs(distance * this.getWidth()) > 1) {
//         const motion = 0.12 * distance
//
//         this.setState({ position: this.state.position + motion }, this.animate)
//       } else {
//         this.skipTo(this.state.destination)
//       }
//     })
//   }
//
//   slide(direction: number) {
//     this.slideTo(Math.round(this.state.destination) + direction)
//   }
//
//   slideTo(destination: number) {
//     this.setState({ destination }, this.animate)
//   }
//
//   skip(direction: number) {
//     this.skipTo(Math.round(this.state.position) + direction)
//   }
//
//   skipTo(position: number) {
//     const destination = toRange(position, this.props.slides.length)
//
//     this.setState({
//       destination,
//       position: destination,
//     })
//   }
//
//   private onTouchStart = (event: TouchEvent) => {
//     this.setState({
//       destination: this.state.position,
//       dragStart: getTouchX(event),
//       dragStartTime: new Date(),
//       dragVelocity: 0,
//     })
//   }
//
//   private onTouchMove = (event: TouchEvent) => {
//     const dragTo = getTouchX(event)
//     const distance = this.state.dragStart - dragTo
//     const unitDistance = distance / this.getWidth()
//     const position = toRange(
//       this.state.position + unitDistance,
//       this.props.slides.length
//     )
//     const now = new Date()
//     const elapsed =
//       now.getTime() -
//       (this.state.dragStartTime ? this.state.dragStartTime.getTime() : 0)
//
//     this.setState({
//       position,
//       destination: position,
//       dragStart: dragTo,
//       dragStartTime: now,
//       dragVelocity:
//         (distance / elapsed) * VELOCITY_TRACKING * -1000 +
//         (1 - VELOCITY_TRACKING) * this.state.dragVelocity,
//     })
//   }
//
//   private onTouchEnd = (event: TouchEvent) => {
//     const dragging =
//       new Date().getTime() -
//         (this.state.dragStartTime ? this.state.dragStartTime.getTime() : 0) <
//       50
//
//     if (dragging && Math.abs(this.state.dragVelocity) > 200) {
//       const direction = this.state.dragVelocity > 0 ? -1 : 1
//       this.slideTo(Math.round(this.state.destination + direction))
//     } else {
//       this.slideTo(Math.round(this.state.destination))
//     }
//   }
//
//   private getWidth() {
//     return this.ref.current ? this.ref.current.offsetWidth : 0
//   }
//
//   render() {
//     // const length = this.props.slides.length
//     // const position = toRange(this.state.position, length)
//     // const index = Math.round(position)
//     // const offset = index - position
//     //
//     // if (index !== this.index) {
//     //   this.index = index
//     //
//     //   if (this.props.onPosition) {
//     //     this.props.onPosition(toRange(this.index, length))
//     //   }
//     // }
//     //
//     // const visible: Array<number> = []
//     //
//     // for (let i = index - PRELOAD_BACK; i <= index + PRELOAD_FORWARD; i++) {
//     //   visible.push((i + length) % length)
//     // }
//     //
//     // const slides = visible.map((i, key) => (
//     //   <div key={`slide-${key}`} style={style.slider__slide}>
//     //     {this.props.slides[i]}
//     //   </div>
//     // ))
//     //
//     // const slides_style = {
//     //   ...style.slider__slides,
//     //   width: `${100 * slides.length}%`,
//     //   transform: `translateX(${(offset - PRELOAD_BACK) *
//     //     (100 / slides.length)}%)`,
//     // }
//
//     return (
//       <div className="ebslider">
//         <div className="swiper-container">
//
//         </div>
//       </div>
//
//       // <div className="img-slider__wrap" style={style.slider} ref={this.ref}>
//       //   <div
//       //     style={style.slider__inner}
//       //     onTouchStart={this.onTouchStart}
//       //     onTouchMove={this.onTouchMove}
//       //     onTouchEnd={this.onTouchEnd}
//       //   >
//       //     <div style={slides_style}>{slides}</div>
//       //   </div>
//       // </div>
//     )
//   }
// }
